import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import moment from "moment";
import { shootFileAssocObj, shootImagesAssocObj, shootSkuAssocObj, shootSkuImagesAssoc } from "../CreateShoot/data";
import { studioAttrGroupLinkedTables } from "../StudioAttributeGroups/data";

export const productionDepartments = {
	DESIGNER: { name: "Designer", key: "DESIGNER" },
};

export const dummySelectedShootData = {
	[studioAttrGroupLinkedTables.shoot.key]: {
		shoot_id: "1234",
		shoot_name: "Shoot 1",
		shoot_brand: "RARE RABBIT",
		shoot_date: "2025-09-28",
		shoot_type: "NEW",
		[shootFileAssocObj]: [],
		[shootImagesAssocObj]: [],
		[shootSkuAssocObj]: [
			{
				i_code: "RR-1234",
				[shootSkuImagesAssoc]: [{ view: "Main", url: "/images/pimImages/ProductImages/melton1.png" }],
			},
		],
	},
	[studioAttrGroupLinkedTables.shoot_details.key]: { id: "12345" },
};
